import * as svg from "../../../assets/play-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const PlayIcon = iconBuilder(svg, "PlayIcon", "0 0 9 9");
